import {MonthPicker} from '@mantine/dates'
import dayjs, {type Dayjs} from 'dayjs'
import {DisabledWrapper} from '../../disabledWrapper/DisabledWrapper.tsx'
import type {DateRange} from '../DateRangeSelector.tsx'

type Props = {
  value: DateRange
  onValueChange: (dateRange: DateRange) => void
  maxDate: Dayjs | undefined
  disabled: boolean
}

export const MonthSelector = ({value, onValueChange, maxDate, disabled}: Props) => {
  return (
    <DisabledWrapper disabled={disabled}>
      <MonthPicker
        value={value.start.toDate()}
        onChange={(date) =>
          date && onValueChange({start: dayjs(date).startOf('month'), end: dayjs(date).endOf('month')})
        }
        maxDate={maxDate?.toDate()}
        withCellSpacing={false}
        allowDeselect={false}
      />
    </DisabledWrapper>
  )
}
